import gql from 'graphql-tag';

export const CUSTOMER_NOTIFICATION_DATA = gql`
    fragment PhraseParts on NotificationPhrase {
        items {
            text
        }
    }
    query NotificationsQuery(
        $context: ContextInput!
        $notificationLocation: NotificationLocationOnPage!
        $lineOfBusiness: LineOfBusinessDomain!
        $pageLocation: PageLocation!
    ) {
        notification(context: $context) {
            inlineNotification(
                notificationLocation: $notificationLocation
                lineOfBusiness: $lineOfBusiness
                pageLocation: $pageLocation
            ) {
                type
                title {
                    ...PhraseParts
                }
                body {
                    ...PhraseParts
                }
                containerLink {
                    uri {
                        value
                    }
                    target
                }
                dismiss {
                    icon {
                        id
                        description
                    }
                }
                form {
                    title
                }
                logo {
                    url
                }
            }
        }
    }
`;
